import VueRouter from 'vue-router';
import routes from './routes';

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const isPublicRoute = to.matched.some(route => route.meta && route.meta.public)
  // If logged in, or going to a public page.
  if (token || to.name === 'Login' || isPublicRoute) {
    // Continue to page.
    next()
  } else {
    // Not logged in, redirect to login.
    next({name: 'Login'})
  }
});

export default router;
